(function () {
  'use strict';
  angular.module('neo.home.adminUsers', []);
}());
